app
    .controller('ClientSelectCtrl', function ($http) {

        const getClients = () => {
            this.loading = true;
            $http
                .get(`/coach/clients`)
                .then((response) => {
                    this.clients = response.data;
                })
                .finally(() => {
                    this.loading = false;
                });
        };

        this.cancel = () => {
            this.dismiss();
        };

        this.isSelected = (client) => {
            return this.selectedClient && this.selectedClient._id === client._id;
        };

        this.onSelect = (client) => {
            this.selectedClient = client;
        };

        this.$onInit = () => {
            getClients();
        };

        this.ok = () => {
            this.close({$value: this.selectedClient});
        };
    })
    .component('clientSelect', {
        template: `
        <div style="width: 100%; min-width: 32vw;">
            <div class="header p-1 text-center font-go-bold" style="background: #1D1D1B; color: #9ac700;">
                <chat-icon width="20" height="20" type="pen" style="position: absolute; left: .25rem; top: .25rem;"></chat-icon>
                {{ 'modal.clientSelect.title' | translate }}
                <div class="right"></div>
            </div>
            <style>
                .isSelected{
                   background-color: #1da1f2;
                }
            </style>
            <div class="body" style="max-height: 400px; overflow-y: scroll;overflow-x: hidden;">
                <div ng-if="!$ctrl.clients.length" style="height: 20vh; display: flex; justify-content: center; align-items: center;">
                    <i class="fa fa-spinner fa-spin" ng-if="$ctrl.loading"></i>
                    <div ng-if="!$ctrl.loading">
                        <p>You don't have any clients.</p>
                    </div>

                </div>
                <div ng-if="!$ctrl.loading && $ctrl.clients" style="border: 1px solid #000; padding: 1rem 0; margin: .5rem; border-radius: 5px;">
                    <div ng-repeat="client in $ctrl.clients" ng-click="$ctrl.onSelect(client)" style="padding: .5rem;" ng-class="{'isSelected': $ctrl.isSelected(client)}">
                        <img ng-src="{{client.picture}}" alt="" style="width: 60px; height: 60px;"/>
                        <span>{{client.displayName}}</span>
                    </div>
                </div>
            </div>
            <div class="footer text-center mb-2" ng-if="!$ctrl.loading && $ctrl.clients">
                <button class="btn btn-slim btn-green font-go-bold btn-200" ng-click="$ctrl.ok()" ng-disabled="!$ctrl.selectedClient">
                    {{ 'modal.clientSelect.btn' | translate }}
                </button>
            </div>
        </div>
        `,
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        },
        controller: 'ClientSelectCtrl'
    });
